import { Button, Spacer } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onOpenTemplateWizard } from 'redux/modules/mixpanel';
import { templateSelector } from 'redux/modules/template-wizard/selectors';
import TemplateWizardGreeting from './TemplateWizardGreeting';
import { block } from './utils';

export type TemplateConfirmationProps = {
  onConfirm?: () => void;
};

const TemplateConfirmation: React.FC<TemplateConfirmationProps> = ({
  onConfirm,
}) => {
  const dispatch = useDispatch();
  const template = useSelector(templateSelector);

  const handleConfirm = useCallback(() => {
    // when the user sees the confirmation screen, that means there's no choice
    // and we already know which of the wizard flows to use, so we can safely
    // dispatch the the "open in wizard" action
    dispatch(onOpenTemplateWizard(template.templateId, template.templateType));
    onConfirm?.();
  }, [dispatch, onConfirm, template.templateId, template.templateType]);

  return (
    <Spacer
      align="center"
      className={block('confirmation')}
      justify="center"
      orientation="vertical"
      space="40px"
    >
      <TemplateWizardGreeting />
      <Button fluid onPress={handleConfirm} size="large" variant="special">
        make clip
      </Button>
    </Spacer>
  );
};

export default TemplateConfirmation;
